import React from 'react';
import {Route, Switch} from "react-router-dom";
import * as innerRoutes from "./InnerRoutings/InnerRoutes";
import AllMeetings from "../ViewAll/index";
import ShowMeeting from "../ViewAll/ShowMeeting/index";
import {Icon} from "semantic-ui-react";

class App extends React.Component {
  render() {
    return(
      <div>
        <div>
          <h5 className="topicColor">
            {
              window.location.pathname === innerRoutes.showMeeting?
              <a onClick={()=> this.props.history.push(innerRoutes.allMeetings)}><Icon name='chevron left' /></a>:""
            }
            <a onClick={()=> this.props.history.push(innerRoutes.allMeetings)}>All Meetings</a>
            {
              window.location.pathname === innerRoutes.showMeeting?
                <span> / </span>
              :""
            }
            {
              window.location.pathname === innerRoutes.showMeeting?
                <span>Meeting Name</span>
                :""
            }
          </h5>
        </div>
        <Switch>
          <Route exact path={innerRoutes.allMeetings} component={AllMeetings}/>
          <Route exact path={innerRoutes.showMeeting} component={ShowMeeting}/>
        </Switch>
      </div>
    );
  }
}

export default App;
